module.exports = __webpack_public_path__ + "static/media/IlotE_synthese_3.e074ca7a.webp";